export default "__VITE_ASSET__CDXj2Rb9__"